export default __webpack_public_path__ + "static/media/patterns.0baec132.png";